import { lazy } from "react"
import { ACL_READ, ACL_SUBJECT_CATEGORY } from "@configs/acl/constants"

const CategoryRoutes = [
  {
    path: "/category/divisions/countries",
    component: lazy(() => import("@views/category/divisions/countries")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/divisions/provinces",
    component: lazy(() => import("@views/category/divisions/provinces")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/divisions/districts",
    component: lazy(() => import("@views/category/divisions/districts")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/divisions/wards",
    component: lazy(() => import("@views/category/divisions/wards")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/tax-departments",
    component: lazy(() => import("@views/category/tax-departments")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/vss-offices",
    component: lazy(() => import("@views/category/vss-offices")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/hospitals",
    component: lazy(() => import("@views/category/hospitals")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/banks",
    component: lazy(() => import("@views/category/banks")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/state-treasurer",
    component: lazy(() => import("@views/category/state-treasurer")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/mail-templates",
    component: lazy(() => import("@views/category/mail-templates")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/business-types",
    component: lazy(() => import("@views/category/business-types")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  },
  {
    path: "/category/business-fields",
    component: lazy(() => import("@views/category/business-fields")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_CATEGORY
    }
  }
]

export default CategoryRoutes
